module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employees"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n        Medarbejdere (" + _vm._s(_vm.employees ? _vm.employees.length : '-') + ")\n    ")]), _vm._v(" "), _vm._l((_vm.employees), function(employee) {
    return _c('div', {
      key: employee.uuid,
      staticClass: "employee"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("\n            " + _vm._s(employee.full_name) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "hours"
    }, [_vm._v("\n            Timer/uge:\n            "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (employee.weekly_hours_working),
        expression: "employee.weekly_hours_working"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (employee.weekly_hours_working)
      },
      on: {
        "keydown": function($event) {
          _vm.showUpdateButton = employee.uuid
        },
        "change": function($event) {
          _vm.showUpdateButton = employee.uuid
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(employee, "weekly_hours_working", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showUpdateButton === employee.uuid),
        expression: "showUpdateButton === employee.uuid"
      }],
      on: {
        "click": function($event) {
          return _vm.updateEmployee(employee)
        }
      }
    }, [_vm._v("\n                 \n                Opdater\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "working-responsible"
    }, [_c('div', {
      staticClass: "mb-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (employee.working_field),
        expression: "employee.working_field"
      }],
      staticStyle: {
        "transform": "scale(1.2)"
      },
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(employee.working_field) ? _vm._i(employee.working_field, null) > -1 : (employee.working_field)
      },
      on: {
        "change": [function($event) {
          var $$a = employee.working_field,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(employee, "working_field", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(employee, "working_field", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(employee, "working_field", $$c)
          }
        }, function($event) {
          return _vm.updateEmployee(employee)
        }]
      }
    }), _vm._v("\n                Udfører arbejde hos kunder\n            ")]), _vm._v(" "), _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (employee.responsible_field),
        expression: "employee.responsible_field"
      }],
      staticStyle: {
        "transform": "scale(1.2)"
      },
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(employee.responsible_field) ? _vm._i(employee.responsible_field, null) > -1 : (employee.responsible_field)
      },
      on: {
        "change": [function($event) {
          var $$a = employee.responsible_field,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(employee, "responsible_field", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(employee, "responsible_field", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(employee, "responsible_field", $$c)
          }
        }, function($event) {
          return _vm.updateEmployee(employee)
        }]
      }
    }), _vm._v("\n                Er opgaveansvarlig\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "working-field-name"
    }, [_c('b', {
      staticStyle: {
        "display": "block",
        "margin-bottom": "4px"
      }
    }, [_vm._v("Medarbejdertype")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (employee.working_field_name),
        expression: "employee.working_field_name"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(employee, "working_field_name", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateEmployee(employee, $event)
        }]
      }
    }, _vm._l((_vm.employeeTypes), function(employeeType) {
      return _c('option', {
        key: employeeType,
        domProps: {
          "value": employeeType
        }
      }, [_vm._v("\n                    " + _vm._s(employeeType) + "\n                ")])
    }), 0)])])
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3756a0f3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3756a0f3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/components/employees.vue
// module id = 815
// module chunks = 0